// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Taux accident du travail
export default class AccidentTravail  {
  // Identifiant unique
  public id: number;
  // Type
  public type: number;
  // Code risque
  public codeRisque: string;
  // Taux patronal
  public tauxPatronal: number;
  // Etablissement
  public etablissementId: number;
  // Branche d'activité
  public brancheId: number;
  // Branche d'activité
  public branche: string;
  // Date d'effet
  public dateEffet: Date;
  // Source
  public source: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.type = 0;
    this.codeRisque = '';
    this.tauxPatronal = 0;
    this.etablissementId = 0;
    this.brancheId = 0;
    this.branche = '';
    this.dateEffet = new Date(1901,1,1,0,0,0,0);
    this.source = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: AccidentTravail): AccidentTravail {
    const newAccidentTravail: AccidentTravail = new AccidentTravail();
    newAccidentTravail.id = obj.id;
    newAccidentTravail.type = obj.type;
    newAccidentTravail.codeRisque = obj.codeRisque;
    newAccidentTravail.tauxPatronal = obj.tauxPatronal;
    newAccidentTravail.etablissementId = obj.etablissementId;
    newAccidentTravail.brancheId = obj.brancheId;
    newAccidentTravail.branche = obj.branche;
    newAccidentTravail.dateEffet = new Date(obj.dateEffet);
    newAccidentTravail.source = obj.source;
    newAccidentTravail.createId = obj.createId;
    newAccidentTravail.failed = obj.failed;
    newAccidentTravail.canUpdate = obj.canUpdate;
    newAccidentTravail.canDelete = obj.canDelete;
    newAccidentTravail.display = obj.display;
    newAccidentTravail.notifDefType = obj.notifDefType;
    return newAccidentTravail;
  }

  public toJsonAccidentTravail (): string {
    const json = {
      type: this.type,
      codeRisque: this.codeRisque,
      tauxPatronal: this.tauxPatronal,
      etablissementId: this.etablissementId,
      brancheId: this.brancheId,
      branche: this.branche,
      dateEffet: this.dateEffet ? new Date (this.dateEffet).toString() : this.dateEffet,
      source: this.source,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromAccidentTravail (obj: AccidentTravail): void {
    this.id = obj.id;
    this.type = obj.type;
    this.codeRisque = obj.codeRisque;
    this.tauxPatronal = obj.tauxPatronal;
    this.etablissementId = obj.etablissementId;
    this.brancheId = obj.brancheId;
    this.branche = obj.branche;
    this.dateEffet = new Date(obj.dateEffet);
    this.source = obj.source;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareAccidentTravail (value: AccidentTravail): boolean {
    return (this.toJsonAccidentTravail() == value.toJsonAccidentTravail());
  }

  public cloneAccidentTravail (): AccidentTravail {
    return AccidentTravail.fromJson(this);
  }

  public createForStoreAccidentTravail (): Promise<AccidentTravail> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/accidenttravails/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAccidentTravail(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreAccidentTravail (): Promise<AccidentTravail> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/accidenttravails/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAccidentTravail(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreAccidentTravail (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/accidenttravails/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/accidenttravails/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/AccidentTravails/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = AccidentTravail.fromJson(listData.reccords[0] as AccidentTravail);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<AccidentTravail> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/AccidentTravails/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = AccidentTravail.fromJson(listData.reccords[0] as AccidentTravail);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(accidentTravails: AccidentTravail[]) {
    accidentTravails.forEach((item) => {
      item.dateEffet = item.dateEffet ? new Date(item.dateEffet) : item.dateEffet;
    })
  }
}
